/* app/page/all */

define(
	'app/page/all',[
		'jquery',
		'util/ajax',
		'app/ui/nav/load',
		'app/ui/track/load',
		'app/ui/rotator/rotator',
		'app/ui/rotator/slick',
		'util/lazyload',
		'app/ui/form/validate',
		'app/ui/listing/masonry',
		'app/ui/equalise/equalise',
		'app/ui/social/instagram-timeline',
		'app/ui/accordion/accordion',
		'app/ui/filter/filter',
		'news-ticker',
		'evensteven',
		'phatfingaz',
		'magnificPopup',
		'jquery.cookie',
		'tabbery',
		'slick'
	],

	function ($, Ajax, NavLoad, Track, Rotator, RotatorSlick, LazyLoad, Validate, Masonry, Equalise, InstagramTimeline , Accordion, Filter, Ticker) {
	    Track.init();
	    Ajax.init();
	    NavLoad.init();
	    LazyLoad.init();
	    Rotator.init();
	    Validate.init();
	    Equalise.init();
	    Accordion.init();

		if($('.js-filtered-listing').length){
			Filter.init();
		}

		if ($('#newsticker').length) {
			Ticker.startTicker('newsticker', { speed: 7, delay: 1000 });
		}

	    if($( '.js-masonry' ).length){
	        Masonry.init();
	    }

		$('.js-hot').phatFingaz();

		$('.js-promo-even').evenSteven({
			resize: true,
			minWidth: '600px',
			maxWidth: '1023px'
		});

		

		function setSmallerFont($el) {
			var fontSizeText = $el.css('font-size');
			var match = fontSizeText.match(/(\d+(\.\d+)?px)/i);
			if (match) {
				var fontSize = parseFloat(match[1], 10);
				fontSize -= 1;
				$el.css('font-size', fontSize);
				return true;
			}
			return false;
		}

		function hasOverflow($el) {
			var width = $el.outerWidth();
			var scrollWidth = $el[0].scrollWidth;
			return scrollWidth > width;
		}

		var timer;
		var $containers = $('.pathways .btn, h1');

		function checkFonts() {
			if (timer) {
				clearTimeout(timer);
			}
			timer = setTimeout(function() {
					$containers.each(function() {
						var $el = $(this);
						var counter = 0;
						$el.css({ 'font-size': '' });
						while (hasOverflow($el) && counter < 40) {
							if (!setSmallerFont($el)) {
								break;
							}
							counter++;
						}
					});
				},
				250);
		}

		if ($containers.length) {
			checkFonts();
			setTimeout(checkFonts, 5000);
			$(window).on('resize', checkFonts);
		}

		function crisisPopup() {
			$.magnificPopup.open({
				items: {
					src: '#crisis-popup',
					type: 'inline'
				},
				callbacks: {
					close: function() {
						//write timestamp to the cookies
						var time = Date.parse($('#crisis-popup').data('timeStamp'));
						$.cookie('CrisisNotificationOpenTime', time, { path: '/' });
					}
				}
			});
		}

		function crisisDismiss() {
			$('.js-crisis-open-container').remove();
		}

		function getCookie(cname) {
			var name = cname + "=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) === 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}

		d = new Date();
		dc = new Date($('#crisis-popup').data('time-stamp'));
		$redisplay = $('#crisis-popup').data('redisplay');

		//crisis popup
		if ($('#crisis-popup').is('div')) {
			if (d >= (parseInt(getCookie('CrisisNotificationOpenTime'), 10) + (parseInt($redisplay, 10) * 60000))) {
				crisisPopup();
			}

			$('.js-crisis-open').click(crisisPopup);
			$('.js-crisis-open-dismiss').click(crisisDismiss);
		}

		$('.js-tabbery').tabbery();

		//customized instagram timeline
		InstagramTimeline.init();

		var popUpVideoUrl = null;

		//html popup
		$('.js-lightbox-html')
			.each(function() {
				$(this).magnificPopup({
					type: 'inline',
					mainClass: 'mfp-html',
					removalDelay: 160,
					preloader: false,
					fixedContentPos: false
				});
			}
			);


		//video popup
		$('.js-lightbox-video')
			.each(function () {
				$(this).magnificPopup({
					type: 'iframe',
					mainClass: 'mfp-video',
					removalDelay: 160,
					preloader: false,
					fixedContentPos: false
				});
			});

		$('.js-lightbox-playlist').each(function () {
			$(this)
				.magnificPopup({
					type: 'inline',
					mainClass: 'mfp-video-playlist',
					callbacks: {
						close: function () {
							//tricky code to fix the bug(video will still autoplay in bg whrn lightbox close, this related to autoplay),
							//so remove the url and manually add back when open light box again
							popUpVideoUrl = $(".js-video-pane").attr("src");
							$(".js-video-pane").attr("src", "");

						}
					}
				});

		});

		$('.js-lightbox-playlist').on('click', function () {
			if (popUpVideoUrl !== '') {
				$(".js-video-pane").attr("src", popUpVideoUrl);
			}
			if (!$('.js-video-thumbnail-carousel').hasClass('slick-initialized')) {
				$('.js-video-thumbnail-carousel').slick({
					dots: false,
					arrows: true,
					slidesToShow: 4,
					slidesToScroll: 1,
					autoplay: false,
					infinite: false
				});
			}
		});

		RotatorSlick.init($('.js-slick-rotator'));
	}
);
